import {
  CommonModule,
  DatePipe,
  DecimalPipe,
  TitleCasePipe,
} from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  inject,
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { Pagination } from '@core/models/pagination.model';
import { BreadCrumbService } from '@core/services/bread-crumb.service';
import { OrderService } from '@core/services/order.service';
import { NotificationFacade } from '@core/facades/notification.facade';
import {
  DropDownModel,
  DropdownComponent,
} from '@shared/ui/dropdown/dropdown.component';
import { BehaviorSubject, Observable, Subscription, take } from 'rxjs';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { TableNavigatorComponent } from '@shared/ui/table-navigator/table-navigator.component';
import { ConfirmDialogComponent } from '@shared/ui/confirm-dialog/confirm-dialog.component';
import { AllOrdersDatum } from '@core/models/admin/orders';
import { dropdownMenuAnimation } from '@shared/animations/animations';
import { StatusComponent } from '@shared/ui/status/status.component';
import { FiltersComponent } from '@shared/ui/filters/filters.component';
import { IFILTER } from 'app/app.constants';
import { MutualFundService } from '@core/services/mutual-fund.service';
import { TableSelectors } from 'app/auth/table-store/table.selectors';
import { Store } from '@ngxs/store';
import { TableActions } from 'app/auth/table-store/table.actions';
import { TableSkeletonLoaderComponent } from '@shared/ui/table-skeleton-loader/table-skeleton-loader.component';
import { ConfirmDialogService } from '@core/services/confirm-dialog.service';
import { PermissionDirective } from '@shared/directives/permission.directive';
@Component({
  selector: 'app-orders',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    ReactiveFormsModule,
    FormsModule,
    RouterLink,
    RouterLinkActive,
    PermissionDirective,
  ],
  templateUrl: './orders.component.html',
  styleUrl: './orders.component.scss',
  animations: [dropdownMenuAnimation],
  providers: [TitleCasePipe, DecimalPipe, DatePipe],
})
export class OrdersComponent implements OnInit, OnDestroy {
  mfService = inject(MutualFundService)
  filterMenuState: 'visible' | 'hidden' = 'hidden';
  subs: Subscription[] = [];
  ordersList: AllOrdersDatum[] = [];
  filteredList: any[] = [];
  actionList: DropDownModel[] = [];
  totalCount: number = 0;
  totalRejected = 0;
  totalInitiated = 0;
  totalProcess = 0;
  totalSales = 0;
  isFiltered: boolean = false;
  isLoading: boolean = false;
  orderId!: string | null;
  orderType!: string | null;
  approveDialogQuestion!: any;
  rejectDialogQuestion!: any;
  dialogQuestion!: any;
  customerOrdersUrl!: string;
  orderApprovalUrl!: string;

  orderListSubject = new BehaviorSubject<any>(null);
  totalCountSubject = new BehaviorSubject<number>(0);
  orderList$ = this.orderListSubject.asObservable();
  totalCount$: Observable<number> = this.totalCountSubject.asObservable();
  isFetchingOrderList$!: Observable<boolean>
  hadFilterBefore = false;
  isFilterActive: boolean = false;




  // reject
  isRejectDialogOpen: boolean = false;
  isRejectInProgress: boolean = false;
  // approve
  isApproveDialogOpen: boolean = false;
  isApproveInProgress: boolean = false;

  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private breadCrumbService = inject(BreadCrumbService);
  private orderService = inject(OrderService);
  private change = inject(ChangeDetectorRef);
  private notify = inject(NotificationFacade);
  private decimalPipe = inject(DecimalPipe);
  private titleCasePipe = inject(TitleCasePipe);
  private datePipe = inject(DatePipe);
  private store = inject(Store);
  private confirmDialogService = inject(ConfirmDialogService);




  filterStructure: IFILTER[] = [
    {
      filterKey: 'date',
      label: 'Date Created',
      type: 'date'

    },
    {
      filterKey: 'type',
      label: 'Order Type',
      type: 'dropdown',
      dropdown: [
        { key: 'invest', value: 'Invest' },
        { key: 'liquidate', value: 'Liquidate' },
        {key: 'partial_redemption', value: 'Partial Redemption'},
        {key: 'total_redemption', value: 'Total Redemption'},
      ],
    },
    {
      filterKey: 'status',
      label: 'Status',
      type: 'dropdown',
      dropdown: [
        { key: 'initiated', value: 'Initiated' },
        { key: 'in_process', value: 'In Process' },
        { key: 'completed', value: 'Completed' },
        { key: 'terminated', value: 'Terminated' },
      ],
    },
    {
      filterKey: 'product_id',
      label: 'Product',
      type: 'dropdown',
      dropdown: []
    },
  ];


  form = new FormGroup({
    created_at: new FormControl(''),
    type: new FormControl(''),
    product_id: new FormControl(''),
    status: new FormControl(''),
  });

  constructor() {
    this.orderList$ = this.store.select(TableSelectors.getTableData('orders'));
    this.totalCount$ = this.store.select(TableSelectors.getTableTotalCount('orders'));
    this.isFetchingOrderList$ = this.store.select(TableSelectors.getTableLoading('orders'));
   }

  ngOnInit() {
    this.customerOrdersUrl = `/admin/orders/customer-orders`;
    this.orderApprovalUrl = `/admin/orders/order-approvals`;
    this.breadCrumbService.setPageBreadCrumb(this.activatedRoute);
    this.filterEventListener();
    this.loadOrdersList();
    this.getOrderCountsByStatus();
    this.getOrderCountsByStatus('initiated');
    this.getOrderListCountByType('liquidate');
    this.getOrderListCountByStatus('in_process');

  }


  loadOrdersList(page = 1) {
      const sub = this.orderList$.pipe(take(1)).subscribe(order => {
        const hasData = Array.isArray(order) && order.length > 0;
        // only dispatch if store is empty
        if (!hasData) {
          this.store.dispatch(new TableActions.LoadTableData({
            tableKey: 'orders',
            params: new Pagination({ 
              skip: (page - 1) * 10, 
              size: 10 
            }),
          }));
        }
      });
      this.subs.push(sub);
      
    }

  filterEventListener() {
    this.activatedRoute.queryParams.subscribe((params) => {
      let query = "";
      if (params[this.filterStructure[1].filterKey]) {
        query = `type=${params['type']}&`;
      }
      if (params[this.filterStructure[2].filterKey]) {
        query += `status=${params['status']}&`;
      }
      if (params[this.filterStructure[3].filterKey]) {
        query += `product_id=${params['product_id']}`;
      }
      if (params['search']) {
        query += `search_text=${params['search']}&`;
      }

      // Handle pagination
      const rawPage = params['page'] ? parseInt(params['page']) : 1;
      const page = rawPage > 1 ? rawPage - 1 : 0;
      const take = 10;
      const skip = page * take;

      if (query) {
        query += `skip=${skip}&take=${take}`;
        this.isFilterActive = true;
        this.hadFilterBefore = true;
        this.store.dispatch(new TableActions.FilterOrderList({ filter: query }));
      } else {
         // only re-fetch if there was a previous filter
         if (this.hadFilterBefore || params['page']) {
          this.hadFilterBefore = false;
          this.store.dispatch(new TableActions.LoadTableData({
            tableKey: 'orders',
            params: new Pagination({ skip: skip, size: take }),
          }));
        }
      }
    });
  }

  navigate(currentPage: number) {
    if (this.isFilterActive) {
      this.router.navigate([], {
        queryParams: { page: currentPage },

        queryParamsHandling: 'merge',
      });
    }
  }

  resetFilters() {
    this.filteredList = [...this.ordersList]; // Reset to show all transactions
    this.form.reset();
    this.isFiltered = false;
  }

  toggle() {
    this.change.detectChanges();
  }

  toggleFilterMenu() {
    this.filterMenuState =
      this.filterMenuState === 'hidden' ? 'visible' : 'hidden';
  }

  initDropdownList(order: AllOrdersDatum) {
    return (this.actionList = [
      {
        action: () => {
          this.router.navigateByUrl(`/admin/orders/details/${order.id}`);
        },
        title: 'View Details',
        show: true,
      },
      {
        action: () => {
            this.router.navigateByUrl(`/admin/orders/approve/${order.id}`)
        },
        title: 'Approve',
        show: order.status !== 'completed',
      },
      {
        action: () => {
          this.orderId = order.id;
          this.orderType = order.type;
          this.isRejectDialogOpen = true;
          this.dialogQuestion = this.setDialogQuestion(order, 'reject');
          this.confirmDialogService.openDialog({
            isOpen: true,
            isDialogLoading: false,
            title: 'Yes, Reject Order',
            description: this.dialogQuestion,
            loadingText: 'Rejecting Order, please wait...',
            action: () => {
              this.rejectOrder();
            },
          });
        },
        title: 'Reject',
        show: order.status !== 'terminated',
      },
      {
        action: () => this.viewAccountDetails(order),
        title: 'View Account',
      },
    ]);
  }
  viewAccountDetails(txn: any) {
    this.router.navigateByUrl(
      `/admin/accounts/${txn.account.account_type}/${txn.account_id}`
    );
  }
  closeApproveDialog() {
    this.isApproveDialogOpen = false;
    this.isApproveInProgress = false;
    this.orderId = null;
    this.dialogQuestion = null;
    this.orderType = null;
    this.isRejectDialogOpen = false;
    this.change.detectChanges();
  }

  closeRejectDialog() {
    this.isRejectDialogOpen = false;
    this.isRejectInProgress = false;
    this.orderId = null;
    this.dialogQuestion = null;
    this.orderType = null;
    this.isApproveDialogOpen = false;
    this.change.detectChanges();
  }
  approveOrder() {
    if(!this.orderType){
      this.notify.info('Order type is required');
    }
    if (!this.orderId) {
      this.notify.info('Order ID is required');
      return;
    }
    this.confirmDialogService.updateDialog({ isDialogLoading: true });

    if (this.orderType === 'liquidate' || this.orderType === 'invest') {
      const sub = this.store.dispatch(new TableActions.ApproveOrder({ orderId: this.orderId }))
      .subscribe({
        complete: () => {
          // This runs when the action completes (success or error)
          this.confirmDialogService.updateDialog({
            isDialogLoading: false,
            isOpen: false,
          });
          this.change.detectChanges()
        },
        error: (err) => {
          this.confirmDialogService.updateDialog({ isDialogLoading: false });
          this.change.detectChanges()
        }
      });
      this.subs.push(sub);
    }
    if (this.orderType === 'partial_redemption' || this.orderType === 'total_redemption') {
      const sub = this.store.dispatch(new TableActions.ApproveMFTransaction({ orderId: this.orderId }))
      .subscribe({
        complete: () => {
          // This runs when the action completes (success or error)
          this.confirmDialogService.updateDialog({
            isDialogLoading: false,
            isOpen: false,
          });
          this.change.detectChanges()
        },
        error: (err) => {
          this.confirmDialogService.updateDialog({ isDialogLoading: false });
          this.change.detectChanges()
        }
      });
      this.subs.push(sub);
    }

  }

  rejectOrder() {
    if(!this.orderType){
      this.notify.info('Order type is required');
    }
    if (!this.orderId) {
      this.notify.info('Order ID is required');
      return;
    }

    this.confirmDialogService.updateDialog({ isDialogLoading: true });
    if (this.orderType === 'liquidate' || this.orderType === 'invest') {
      const sub = this.store.dispatch(new TableActions.RejectOrder({ orderId: this.orderId }))
      .subscribe({
        complete: () => {
          // This runs when the action completes (success or error)
          this.confirmDialogService.updateDialog({
            isDialogLoading: false,
            isOpen: false,
          });
          this.change.detectChanges()
        },
        error: (err) => {
          this.confirmDialogService.updateDialog({ isDialogLoading: false });
          this.change.detectChanges()
        }
      });
      this.subs.push(sub);
    }
    if (this.orderType === 'partial_redemption' || this.orderType === 'total_redemption') { 
      const sub = this.store.dispatch(new TableActions.RejectMFTransaction({ orderId: this.orderId }))
      .subscribe({
        complete: () => {
          // This runs when the action completes (success or error)
          this.confirmDialogService.updateDialog({
            isDialogLoading: false,
            isOpen: false,
          });
          this.change.detectChanges()
        },
        error: (err) => {
          this.confirmDialogService.updateDialog({ isDialogLoading: false });
          this.change.detectChanges()
        }
      });
      this.subs.push(sub);
    }
  }

  getOrderCountsByStatus(status: string = 'terminated') {
    const sub = this.orderService.getOrderListCount(status).subscribe({
      next: (resp: any) => {
        if (status === 'terminated') {
          this.totalRejected = resp.data.count;
        }
        if (status === 'initiated') {
          this.totalInitiated = resp.data.count;
        }
        this.change.detectChanges();
      },
      error: (err) => { },
    });
    this.subs.push(sub);
  }

  getOrderListCountByStatus(status: string = 'in_process') {
    const sub = this.orderService.getOrderListCount(status).subscribe({
      next: (resp: any) => {
        if (status === 'in_process') {
          this.totalProcess = resp.data.count;
          this.change.detectChanges();
        }
      },
      error: (err) => { },
    });
    this.subs.push(sub);
  }


  getOrderListCountByType(type: string) {
    const sub = this.orderService.getOrderListCountByType(type).subscribe({
      next: (resp: any) => {
        if (type === 'liquidate') {
          this.totalSales = resp.data.count; // Assuming this.totalSales should now represent Liquidate investment
          this.change.detectChanges();
        }
      },
      error: (err) => { },
    });
    this.subs.push(sub);
  }


  setDialogQuestion(order: AllOrdersDatum, type: 'approve' | 'reject') {
    const accountName =
      order.account?.account_type === 'corporate'
        ? order.account?.corporate_kyc?.name || '—'
        : `${this.titleCasePipe.transform(order.account.user_profile?.first_name)} ${this.titleCasePipe.transform(order.account.user_profile?.last_name)}`;
    const productName = order?.product ? order?.product?.name : 'not provided';
    let amount = this.decimalPipe.transform(order.amount / 100, '1.2-2');
    let date = this.datePipe.transform(order.created_at, 'medium');

    let orderTypeClass =
      order.type === 'invest'
        ? 'bg-green-100 text-mango-pineGreen'
        : 'bg-mango-shellRed text-mango-red707';

    return `
          <p>Are you sure you want to ${type} this Order? This action cannot be undone. </p>

          <div class="flex flex-col text-sm gap-1 mt-1">
            <h5>Recipient Details</h5>
            <div class="flex justify-between">
              <div class="text-gray-500"> User/Organization: </div>
              <div class="font-bold">${accountName}</div>
            </div>
            <div class="flex justify-between">
              <div class="text-gray-500"> Order Type: </div>
              <span
                class="inline-flex w-fit items-center gap-1 rounded-full px-2 py-1 text-xs font-medium uppercase ${orderTypeClass}"
              >
              ${order.type ? order.type : (order.type == 'total_redemption'||order.type=='partial_redemption') ? 'Mutual Funds': 'not provided'}
              </span>
            </div>
            <div class="flex justify-between">
              <div class="text-gray-500"> Products: </div>
              <div class="font-bold"> ${productName}</div>
            </div>
            <div class="flex justify-between">
              <div class="text-gray-500"> Amount: </div>
              <div class="font-bold">₦${amount}</div>
            </div>
            <div class="flex justify-between">
              <div class="text-gray-500"> Date: </div>
              <div class="font-bold">${date}</div>
            </div>
          </div>
          `;
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
